import { api, fmtEUR } from "@/lib/api";
import { DecimalInput } from "@/components/DecimalInput";
import { RABATT_OPTS } from "@/lib/decimal";
import { toast } from "sonner";

// Gesamtrabatt % (nur Bauteile/Leistungen, NICHT Versand; nach Positionsrabatten) + Summen nach Rabatten
export function GesamtrabattSummen({ order, locked, readOnly, onUpdated }) {
  const s = order.summen || {};
  const save = async (v) => {
    try { const r = await api.patch(`/auftraege/${order.id}`, { gesamtrabatt_prozent: v ?? 0 }); onUpdated(r.data); toast.success("Gesamtrabatt gespeichert."); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gesamtrabatt konnte nicht gespeichert werden."); }
  };
  const Row = ({ l, v, strong, testId, tone = "text-slate-600" }) => (
    <div className={`flex justify-between gap-6 ${strong ? "font-semibold text-slate-900 border-t border-slate-200 pt-1 mt-1" : tone}`} data-testid={testId}>
      <span>{l}</span><span className="font-mono">{v}</span>
    </div>
  );
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-4 px-4 py-3 border-t border-slate-200 bg-slate-50/50" data-testid="auftrag-rabatt-summen">
      <div className="flex items-start gap-2">
        <label htmlFor="gesamtrabatt-input" className="text-sm text-slate-700 leading-8">Gesamtrabatt %</label>
        <DecimalInput id="gesamtrabatt-input" disabled={locked || readOnly} value={order.gesamtrabatt_prozent || 0} opts={RABATT_OPTS} className="w-20"
          aria-label="Gesamtrabatt in Prozent" testId="auftrag-gesamtrabatt" onCommit={save} />
        <span className="text-xs text-slate-500 leading-8">auf Bauteile/Leistungen, ohne Versand</span>
      </div>
      <div className="sm:ml-auto w-full sm:w-80 text-sm">
        {s.positionsrabatt_betrag > 0 && <Row l="Positionsrabatte" v={`−${fmtEUR(s.positionsrabatt_betrag)}`} tone="text-amber-700" testId="auftrag-positionsrabatt" />}
        {s.gesamtrabatt_betrag > 0 && <Row l={`${s.gesamtrabatt_text} von ${fmtEUR(s.gesamtrabatt_basis)}`} v={`−${fmtEUR(s.gesamtrabatt_betrag)}`} tone="text-amber-700" testId="auftrag-gesamtrabatt-betrag" />}
        <Row l="Netto" v={fmtEUR(order.summe_netto)} testId="auftrag-summen-netto" />
        {(s.steuer || []).map((st) => <Row key={st.satz} l={`MwSt ${Number(st.satz).toLocaleString("de-DE")} %`} v={fmtEUR(st.mwst)} testId={`auftrag-summen-mwst-${st.satz}`} />)}
        <Row l="Brutto" v={fmtEUR(order.summe_brutto)} strong testId="auftrag-summen-brutto" />
      </div>
    </div>
  );
}
